export class Department{
    ID: number;
    DepartmentName: string;
    CreatedBy: string;
    CreatedDate: Date;
    ModifiedBy: string;
    ModifiedDate: Date;
  }
  